import { classNames, React, useState } from '@digsup/core-ui';
import PropTypes from 'prop-types';
import { Button } from '@digsup/components-button';
import { Icon } from '@digsup/components-icon';
import iconTilt from './tilt.svg';
import iconTiltActive from './tilt-active.svg';
import { styles } from './MapControls.scss';

const cx = classNames.bind(styles);

export const MapControls = ({ map }) => {
  const [tilt, setTilt] = useState(true);
  const [zoom, setZoom] = useState(12);

  const rotate = () => {
    const heading = map.getHeading() || 0;
    map.setHeading(heading + 90);
  };

  const toggleTilt = () => {
    const value = map.getTilt() === 45 ? 0 : 45;
    setTilt(value === 45);
    map.setTilt(value);
  };

  const changeZoom = option => {
    const newZoom = map.getZoom() + option;
    setZoom(newZoom);
    map.setZoom(newZoom);
  };

  return (
    <div className={cx('c-map-controls')}>
      {zoom > 17 && (
        <div>
          <Button
            variant="flat"
            size="medium"
            iconOnly
            icon={
              <img
                src={tilt ? iconTiltActive : iconTilt}
                className="c-map-controls__btn-tilt-img"
                alt="tilt"
              />
            }
            onClick={toggleTilt}
            className="c-map-controls__btn">
            Tilt
          </Button>
          {tilt && (
            <Button
              variant="flat"
              size="medium"
              iconOnly
              icon={<Icon name="rotate" size="small" />}
              onClick={rotate}
              className="c-map-controls__btn">
              Rotate
            </Button>
          )}
        </div>
      )}
      <div className="u-margin-left-auto">
        <Button
          variant="flat"
          size="medium"
          iconOnly
          icon={<Icon name="plus" size="small" />}
          onClick={() => changeZoom(1)}
          className="c-map-controls__btn">
          Zoom in
        </Button>
        <Button
          variant="flat"
          size="medium"
          iconOnly
          icon={<Icon name="minus" size="small" />}
          onClick={() => changeZoom(-1)}
          className="c-map-controls__btn">
          Zoom out
        </Button>
      </div>
    </div>
  );
};

MapControls.propTypes = {
  map: PropTypes.any,
};
